<template>
  <div class="container-fluid component">
    <p class="h4 heading branding">
      Welcome, <span class="text-capitalize">{{ user.companyName }}</span> user!
      <help :portal="portal" class="pull-right padding-80" />
    </p>
    <p v-if="portal == 'mycfm'">
      Please fill out the required information below to register as a new user of the CFM web portal.<br />
      Your request will be routed to a CFM Sponsor for approval.
    </p>
    <form @submit.prevent>
      <div class="name-form-group">
        <label class="control-label required" for="firstName">Name</label>
        <div class="form-inline">
          <div class="form-group">
            <input
              id="firstName"
              v-model.trim="user.firstName"
              v-focus
              type="text"
              class="form-control"
              placeholder="First Name"
              @blur="$v.user.firstName.$touch();"
            />
            <div v-if="!$v.user.firstName.required && $v.user.firstName.$error" class="text-danger">
              First Name cannot be empty
            </div>
            <div v-if="!$v.user.firstName.maxLength && $v.user.firstName.$error" class="text-danger">
              Allowed upto 100 characters only.
            </div>
          </div>

          <div class="form-group">
            <input
              v-model.trim="user.middleName"
              type="text"
              class="form-control middle-name"
              placeholder="Middle Name"
              @blur="$v.user.middleName.$touch();"
            />
            <div v-if="!$v.user.middleName.maxLength && $v.user.middleName.$error" class="text-danger">
              Allowed upto 100 characters only.
            </div>
          </div>

          <div class="form-group">
            <input
              v-model.trim="user.lastName"
              type="text"
              placeholder="Last Name"
              class="form-control"
              @blur="$v.user.lastName.$touch();"
            />
            <div v-if="!$v.user.lastName.required && $v.user.lastName.$error" class="text-danger">
              Last Name cannot be empty
            </div>
            <div v-if="!$v.user.lastName.maxLength && $v.user.lastName.$error" class="text-danger">
              Allowed upto 100 characters only.
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="email" class="control-label">E-mail Address</label>
        <input id="email" v-model.trim="user.email" type="email" class="form-control" readonly disabled />
      </div>

      <div class="form-group">
        <label for="country" class="control-label required">Country of Citizenship</label>
        <select id="country" v-model="user.countryId" class="form-control" @change="displayGreenCard">
          <option value="">select</option>
          <option v-for="country in countries" :key="country.cntryId" :value="country.cntryId">
            {{ country.cntryNm }}
          </option>
        </select>
        <div v-if="$v.user.countryId.$invalid && $v.user.countryId.$dirty" class="text-danger">Select your country</div>
      </div>

      <div v-if="showGreenCardDetails" class="row form-group">
        <div class="col-md-3">
          <label class="control-label required" for="greenCard">US Green Card Holder?</label>
          <div class="form-inline">
            <div class="form-group">
              <select id="country" v-model="user.greenCard" class="form-control">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="user.greenCard == 'Yes'" class="col-md-3">
          <label class="control-label required" for="greenCardExp">Expiration Date</label>
          <div class="form-inline">
            <div class="form-group">
              <datepicker
                id="greenCardExp"
                v-model.trim="user.greenCardExp"
                v-focus
                placeholder="(MM/DD/YYYY)"
                :bootstrap-styling="true"
                format="MM/dd/yyyy"
                @blur="$v.user.greenCardExp.$touch();"
              ></datepicker>
              <div v-if="!$v.user.greenCardExp.required && $v.user.greenCardExp.$error" class="text-danger">
                Expiration date cannot be empty
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="user.companyMaterialAccess" class="form-group">
        <label for="" class="control-label required">Do you need the ability to Purchase Parts?</label>
        <div class="radio-btns">          
            <div class="radio-btn">
              <input
                id="materialBuyerAccessYes"
                v-model="user.materialBuyerAccess"
                type="radio"
                value="Yes"
              />
              <label for="materialBuyerAccessYes">Yes</label>
            </div>
            <div class="radio-btn">
              <input id="materialBuyerAccessNo" v-model="user.materialBuyerAccess" type="radio" value="No"/>
              <label for="materialBuyerAccessNo">No</label>
            </div>
        </div>
        <div v-if="!$v.user.materialBuyerAccess.required && $v.user.materialBuyerAccess.$error" class="text-danger">
          Please select do you need the ability to Purchase Parts
        </div>
      </div>

      <div class="form-group">
        <label for="comments" class="control-label">Comments</label>
        <textarea id="comments" v-model.trim="user.comments" maxlength="200" class="form-control" rows="2" />
        <div v-if="!$v.user.comments.maxLength && $v.user.comments.$error" class="text-danger">
          Allowed upto 200 characters only.
        </div>
      </div>

      <div class="checkbox privacy-form-group">
        <label class="checkbox-inline" @click="readPrivacyClicked">
          <input v-model="privacy" type="checkbox" @click="readPrivacyClicked" /> I have read and accept the
        </label>
        <span v-if="portal !== 'gehonda'">
          <a href="/custom-login/cfm-privacy-policy.html" target="_blank" @click="readPrivacy = true;">
            Privacy Policy</a
          >
          <span> and the </span>
          <a href="/custom-login/cfm-terms-conditions.html" target="_blank" @click="readTC = true;"
            >Terms and Conditions</a
          >
        </span>
        <div v-if="showPrivacy" class="text-danger">
          Please read the Privacy Policy & Terms and Conditions before accepting
        </div>
        <div v-else-if="!$v.privacy.$model && $v.privacy.$dirty" class="text-danger">
          Please read and accept the Privacy Policy & Terms and Conditions
        </div>
      </div>

      <div id="recaptcha">
        <BotControlAOB
          :display-data="showRecaptcha"
          @closeModal="showRecaptcha = false;"
          @recaptchaResponseData="submitRequestAccess"
        />
      </div>

      <div class="action-btns">
        <input type="submit" class="btn btn-sm btn-primary" value="Request Access" @click.prevent="displayCaptcha" />
        <input type="button" value="Back" class="btn btn-sm btn-default" @click="goBack" />
      </div>
    </form>

    <!-- modal for duplicate Registration -->
    <modal v-model="showErrorModal" effect="fade">
      <div slot="modal-header" class="header"></div>

      <div v-if="portal == 'mygea'">
        <p>
          Our records indicate there is an existing access request associated with your email address. Please
          <a :href = customerSupportURL target="_blank" class="underline">Contact Our Support Team</a>
          with your access request details, including: your email address and the
          company you are associated with and they will assist you.
        </p>
      </div>

      <div v-if="portal == 'gehonda'">
        <p>
          Our records indicate there is an existing access request associated with your email address. Please
          <a :href = customerSupportURLGEH target="_blank" class="underline">Contact Our Support Team</a>
          with your access request details, including: your email address and the
          company you are associated with and they will assist you.
        </p>
      </div>

      <div v-if="portal == 'mycfm'">
        <div v-if="isSAUser">
          <p>
            Our records indicate there is an existing access request associated with your email address. Please contact
            the CFM Support Team with your access request details, including: your email address and the company you are
            associated with and they will assist you.
          </p>
          <div><strong>Call or e-mail our CFM Support Team! </strong></div>
          <br />
          <div><strong>France: </strong>+33 1 64 14 88 66</div>
          <div><strong>E-mail: </strong> <a href="mailto:cfm.csc@safrangroup.com">cfm.csc@safrangroup.com</a></div>
        </div>
        <div v-else>
          <p>
            Our records indicate there is an existing access request associated with your email address. Please
            <a :href = customerSupportURLCFM target="_blank" class="underline">Contact Our Support Team</a>
            with your access request details, including: your email address and the company you are
            associated with and they will assist you.
          </p>
        </div>
      </div>

      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-sm btn-primary" @click="showErrorModal = false;">Close</button>
      </div>
    </modal>

    <!-- modal notification failure -->
    <modal v-model="registrationFailed" effect="fade" width="40%">
      <div slot="modal-header" class="modal-header"><strong class="modal-title">Message</strong></div>
      <div>
        <span class="fa fa-exclamation text-warning fa-lg" /> Your request could not be submitted due to an intermittent
        connection issue! Please try submitting your request again after sometime.
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button id="forgotUser" type="button" class="btn btn-sm btn-primary" @click="regFailed();">OK</button>
      </div>
    </modal>

    <spinner
      ref="spinner"
      v-model="showSpinner"
      fixed
      size="lg"
      text="Please be patient we are processing your request. Please do not hit the back button / resubmit
        or a duplicate request may be created."
    />
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import modal from "build-ui-x/src/Modal";
import { required, requiredIf, maxLength } from "vuelidate/lib/validators";
import { addNewNonGeUser } from "@/services/endpointsService";
import spinner from "build-ui-x/src/Spinner";
import help from "./HelpInfo";
import moment from "moment";
import { mapState } from "vuex";
import BotControlAOB from "@/mycfm/components/new-company/BotControlAOB";

export default {
  components: {
    Datepicker,
    modal,
    spinner,
    help,
    BotControlAOB
  },
  props: {
    portal: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showSpinner: false,
      readPrivacy: false,
      readTC: false,
      privacy: false,
      showPrivacy: false,
      showGreenCardDetails: false,
      showRecaptcha: false,
      showErrorModal: false,
      isSAUser: false,
      registrationFailed: false,
      customerSupportURL: "https://www.geaerospace.com/support",
      customerSupportURLGEH: "https://www.gehonda.com/contact/",
      customerSupportURLCFM: "https://www.cfmaeroengines.com/contact/"
    };
  },
  computed: {
    ...mapState("user", ["user"]),
    ...mapState("country", ["countries"])
  },
  validations: {
    user: {
      firstName: {
        required,
        maxLength: maxLength(100)
      },
      middleName: {
        maxLength: maxLength(100)
      },
      lastName: {
        required,
        maxLength: maxLength(100)
      },
      countryId: {
        required
      },
      greenCard: {
        required: requiredIf(function() {
          return this.user.countryId != 232;
        })
      },
      greenCardExp: {
        required: requiredIf(function() {
          return this.user.greenCard === "Yes";
        })
      },
      comments: {
        maxLength: maxLength(200)
      },
      materialBuyerAccess: {
        required : requiredIf(function() {
          return this.user.companyMaterialAccess
        })
      }
    },
    privacy: {
      required: function(value) {
        return value;
      }
    }
  },
  created() {
    this.$store.dispatch("country/getCountries");
    this.isSAUser = this.user.mdmOrgZone == "SA";
  },
  methods: {
    regFailed() {
      this.registrationFailed = false;
      window.location.reload();
    },
    displayCaptcha() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.showRecaptcha = true;
      if (window.grecaptcha) {
        window.grecaptcha.reset();
      }
    },
    submitRequestAccess(recaptchaValue) {
      const data = {
        firstName: this.user.firstName,
        middleName: this.user.middleName,
        lastName: this.user.lastName,
        email: this.user.email,
        mdmOrgId: this.user.mdmOrgId,
        mdmOrgName: this.user.mdmOrgName,
        countryId: this.user.countryId,
        greenCard: this.user.greenCard,
        greenCardExp: "",
        comments: this.user.comments,
        materialBuyerAccess: this.user.materialBuyerAccess
      };

      if (this.user.greenCardExp) {
        data.greenCardExp = moment(this.user.greenCardExp).format("MM/DD/YYYY");
      }

      const config = {
        headers: {
          "g-recaptcha-response": recaptchaValue
        }
      };

      this.showSpinner = true;
      addNewNonGeUser(data, config)
        .then(data => {
          if (data) {
            this.$store.dispatch("user/setActivePage", "thankyouPage");
          }
        })
        .catch(error => {
          if (error.response.data.errorType && error.response.data.errorType == "Duplicate Registration") {
            // show error modal
            this.showErrorModal = true;
          } else {
            this.registrationFailed = true;
          }
        })
        .finally(() => {
          // hide spinner
          this.showSpinner = false;
        });
    },
    goBack() {
      this.$store.dispatch("user/clearNonGeForm");
      this.$store.dispatch("user/setActivePage", "welcomePage");
    },
    readPrivacyClicked(e) {
      if (!this.readPrivacy || !this.readTC) {
        e.preventDefault();
        this.showPrivacy = true;
      } else {
        this.showPrivacy = false;
      }
    },
    displayGreenCard: function(event) {
      this.showGreenCardDetails = event.target.value != 232 ? true : false;
      this.user.countryId = event.target.value;
    }
  }
};
</script>

<style lang="less" scoped>
form {
  margin-top: 25px;
  padding-bottom: 130px;
}
.privacy-form-group {
  margin-bottom: 25px;
}

.header {
  visibility: hidden;
  height: 30px;
}

.branding {
  font-size: 23px;
  font-weight: bold;
  color: #004bbd;
  font-family: apexSans;
}

.name-form-group {
  margin-bottom: 15px;
  .form-group {
    vertical-align: top;
    .form-control {
      width: 200px;
      margin-right: 10px;
    }
  }
}
.fullname-label {
  display: block;
}

.form-group {
  input:not([type=radio]),
  textarea,
  select {
    width: 280px;
  }
}
.checkbox-inline input {
  width: auto;
}

@media all and (max-width: 770px) {
  .name-form-group {
    .form-group {
      .form-control {
        width: 280px;
      }
    }
  }
}
</style>
